import { getConfig } from 'utils/config';
import { RecentRelativeTimeRange } from 'utils/time';

export const ACTIONS_TYPES = {
  COMMON: {
    QUICK_UPDATE: 'dcd/common::get',
    GET_ALL_RESOURCES: 'dcd/get-all-resources::get',
    PENDING_ACTION: 'dcd/common/pending_action',
    REMOVE_PENDING_ACTION: 'dcd/common/remove_pending_action',
    RESIZE_SCREEN: 'dcd/common/resizescreen::get',
    EMBED: 'dcd/common/embed',
    GET_LOCATIONS: 'dcd/common/get-location::get',
    GET_FEATURES: 'dcd/common/get-features::get',

    BUFFER_CLONE_DATA: 'dcd/common/buffer/clone',

    NOTIFICATION_SHOW: 'dcd/common/notification/show',
  },

  PROVISIONING: {
    ADD: 'dcd/provisioning/add::get',
  },

  CONTRACT: {
    GET_ALL: 'dcd/contracts/get-all-contracts::get',
  },

  // [HOT_RESOLVER]
  DATA_CENTER_DELETE: {
    GET: 'datacenters/{datacenterId}::get',
    GET_ALL: 'datacenters::get-all',
    CREATE: 'datacenters::create',
  },

  DATA_CENTER: {
    GET: 'dcd/data-center/get::get',
    GET_ALL: 'dcd/data-center/get-all::get',
    CREATE: 'dcd/data-center/create::create',
    UPDATE: 'dcd/data-center/update::update',
    DELETE: 'dcd/data-center/delete::delete',
    GET_SERVER: 'dcd/data-center/server/get::get',
    CREATE_SERVER: 'dcd/data-center/server/create::create',
    GET_STORAGE: 'dcd/data-center/server/storage/get',
  },

  LAN: {
    CREATE: 'dcd/lan/create::create',
    GET: 'dcd/lan/get::get',
    GET_ALL: 'dcd/lan/get-all::get',
    UPDATE: 'dcd/lan/update::update',
    DELETE: 'dcd/lan/delete::delete',
  },

  STORAGE: {
    CREATE: 'dcd/storage/create::create',
    GET: 'dcd/storage/get::get',
    GET_ALL: 'dcd/storage/get-all::get',
    UPDATE: 'dcd/storage/update::update',
    DELETE: 'dcd/storage/delete::delete',
    CREATE_SNAPSHOT: 'dcd/storage/create-a-snapshot::update',
  },

  IDENTITY: {
    LOGIN: 'dcd/identity/login::get',
  },

  IMAGES: {
    GET_ALL: 'dcd/images/get-all::get',
    GET: 'dcd/images/get-all::get',
    GET_UPLOADED: 'dcd/images/get-uploaded',
    GET_SNAPSHOT: 'dcd/images/get-snapshot',
    UPDATE: 'dcd/images/update::update',
    DELETE: 'dcd/images/delete::delete',
  },

  SSH_KEYS: {
    CREATE: 'dcd/ssh-key/create',
    UPDATE: 'dcd/ssh-key/update',
    DELETE: 'dcd/ssh-key/delete',
    GET_ALL: 'dcd/ssh-key/get-all::get',
  },

  USER: {
    CREATE: 'dcd/user/create::create',
    UPDATE: 'dcd/user/update::update',
    DELETE: 'dcd/user/delete::delete',
    GET_ALL: 'dcd/user/get-all::get',
    GET: 'dcd/user/get::get',
    GET_CURRENT_USER: 'dcd/user/get-current-user::get',
  },

  GROUP: {
    CREATE: 'dcd/group/create::create',
    UPDATE: 'dcd/group/update::update',
    DELETE: 'dcd/group/delete::delete',
    GET_ALL: 'dcd/group/get-all::get',
    GET: 'dcd/group/get::get',
    GET_USERS: 'dcd/group/get-users::get',
    ADD_USER: 'dcd/group/add-user::create',
    DELETE_USER: 'dcd/group/delete-user::delete',
    GET_RESOURCES: 'dcd/group/get-resources::get',
    ADD_RESOURCE: 'dcd/group/add-resource::create',
    DELETE_RESOURCE: 'dcd/group/delete-resource::delete',
    GET_USER_GROUPS: 'dcd/group/get-user-groups::get',
  },

  SERVER: {
    GET_ALL: 'dcd/server/get-all::get',
    GET: 'dcd/server/get::get',
    ACTION: 'dcd/server/action::update',
    UPDATE: 'dcd/server/update::update',
    DELETE: 'dcd/server/delete::delete',
    ATTACH_CD_ROM: 'dcd/server/attach-cdrom::update',
    DEATTACH_CD_ROM: 'dcd/server/deattach-cdrom::delete',
    ATTACH_VOLUME: 'dcd/server/attach-volume::update',
    DEATTACH_VOLUME: 'dcd/server/deattach-volume::delete',
    GET_OVERALL_SERVERS: 'dcd/server/get-overall-servers::get',
  },

  KUBERNETES: {
    CLUSTER: {
      CREATE: 'dcd/kubernetes/cluster/create::create',
      UPDATE: 'dcd/kubernetes/cluster/update::update',
      DELETE: 'dcd/kubernetes/cluster/delete::delete',
      GET: 'dcd/kubernetes/cluster/get::get',
      GET_ALL: 'dcd/kubernetes/cluster/get_all::get',
      GET_KUBE_CONFIG_FILE: 'dcd/kubernetes/cluster/get_kube_config::get',
    },
    NODEPOOL: {
      CREATE: 'dcd/kubernetes/cluster/nodepool/create::create',
      UPDATE: 'dcd/kubernetes/cluster/nodepool/update::update',
      DELETE: 'dcd/kubernetes/cluster/nodepool/delete::delete',
      GET: 'dcd/kubernetes/cluster/nodepool/get::get',
      GET_ALL: 'dcd/kubernetes/cluster/nodepool/get_all::get',
    },
    NODE: {
      RECREATE: 'dcd/kubernetes/cluster/nodepool/node/update::update',
      DELETE: 'dcd/kubernetes/cluster/nodepool/node/delete::delete',
      GET: 'dcd/kubernetes/cluster/nodepool/node/get::get',
      GET_ALL: 'dcd/kubernetes/cluster/nodepool/node/get_all::get',
    },
    VERSION: {
      GET_ALL: 'dcd/kubernetes/version/get_all',
      GET_DEFAULT: 'dcd/kubernetes/version/get_default',
      GET_COMPATIBILITIES: 'dcd/kubernetes/version/get_compatibilities',
    },
  },

  BILLING: {
    GET_PROFILE: 'billing/profile/get::get',
    GET_PRODUCTS: 'billing/products/get::get',
    GET_USAGE: 'billing/usage/get::get',
    GET_USAGE_BY_DATACENTER: 'billing/usage/get_by_datacenter::get',
    GET_INVOICES: 'billing/invoices/get::get',
    GET_INVOICES_BY_ID: 'billing/invoices/get_by_id::get',
    GET_INVOICES_BY_PERIOD: 'billing/invoices/get_by_period::get',
    GET_TRAFFIC: 'billing/traffic/get::get',
    GET_TRAFFIC_BY_PERIOD: 'billing/traffic/get_by_period::get',
    GET_EVN: 'billing/traffic/get::get',
    GET_EVN_BY_PERIOD: 'billing/traffic/get_by_period::get',
  },

  IP: {
    CREATE: 'dcd/ip/create::create',
    GET: 'dcd/ip/get::get',
    GET_ALL: 'dcd/ip/get-all::get',
    UPDATE: 'dcd/ip/update::update',
    DELETE: 'dcd/ip/delete::delete',
  },

  BACKUP_UNIT: {
    CREATE: 'dcd/backupunit/create::create',
    GET: 'dcd/backupunit/get::get',
    GET_ALL: 'dcd/backupunit/get-all::get',
    UPDATE: 'dcd/backupunit/update::update',
    DELETE: 'dcd/backupunit/delete::delete',
  },

  LOAD_BALANCER: {
    CREATE: 'dcd/loadbalancer/create::create',
    GET: 'dcd/loadbalancer/get::get',
    GET_ALL: 'dcd/loadbalancer/get-all::get',
    UPDATE: 'dcd/loadbalancer/update::update',
    DELETE: 'dcd/loadbalancer/delete::delete',
    ATTACH_NIC: 'dcd/loadbalancer/attach-nic::create',
    DEATTACH_NIC: 'dcd/loadbalancer/deattach-nic::create',
  },

  NIC: {
    CREATE: 'dcd/nic/create::create',
    GET: 'dcd/nic/get::get',
    GET_ALL: 'dcd/nic/get-all::get',
    UPDATE: 'dcd/nic/update::update',
    DELETE: 'dcd/nic/delete::delete',
    FIREWALL_RULE_ADD: 'dcd/nic/firewall-rule-add::create',
    FIREWALL_RULE_GET: 'dcd/nic/firewall-rule-get::get',
    FIREWALL_RULE_GET_ALL: 'dcd/nic/firewall-rule-get-all::get',
    FIREWALL_RULE_DELETE: 'dcd/nic/firewall-rule-delete::delete',
    FIREWALL_RULE_UPDATE: 'dcd/nic/firewall-rule-update::update',
    FLOWLOG_ADD: 'dcd/nic/flowlog-add::create',
    FLOWLOG_GET: 'dcd/nic/flowlog-get::get',
    FLOWLOG_GET_ALL: 'dcd/nic/flowlog-get-all::get',
    FLOWLOG_DELETE: 'dcd/nic/flowlog-delete::delete',
    FLOWLOG_UPDATE: 'dcd/nic/flowlog-update::update',
  },

  NETWORK_LOAD_BALANCER: {
    CREATE: 'dcd/network-loadbalancer/create::create',
    GET: 'dcd/network-loadbalancer/get::get',
    GET_ALL: 'dcd/network-loadbalancer/get-all::get',
    UPDATE: 'dcd/network-loadbalancer/update::update',
    DELETE: 'dcd/network-loadbalancer/delete::delete',
    CREATE_FORWARDING_RULE: 'dcd/network-loadbalancer/create-forwarding-rule::create',
    GET_FORWARDING_RULE: 'dcd/network-loadbalancer/get-forwarding-rule::get',
    GET_ALL_FORWARDING_RULE: 'dcd/network-loadbalancer/get-all-forwarding-rule::get',
    UPDATE_FORWARDING_RULE: 'dcd/network-loadbalancer/update-forwarding-rule::update',
    PARIALLY_UPDATE_FORWARDING_RULE: 'dcd/network-loadbalancer/partially-update-forwarding-rule::update',
    DELETE_FORWARDING_RULE: 'dcd/network-loadbalancer/delete-forwarding-rule::delete',
  },

  APPLICATION_LOAD_BALANCER: {
    CREATE: 'dcd/application-loadbalancer/create::create',
    GET: 'dcd/application-loadbalancer/get::get',
    GET_ALL: 'dcd/application-loadbalancer/get-all::get',
    UPDATE: 'dcd/application-loadbalancer/update::update',
    DELETE: 'dcd/application-loadbalancer/delete::delete',
    CREATE_FORWARDING_RULE: 'dcd/application-loadbalancer/create-forwarding-rule::create',
    GET_FORWARDING_RULE: 'dcd/application-loadbalancer/get-forwarding-rule::get',
    GET_ALL_FORWARDING_RULE: 'dcd/application-loadbalancer/get-all-forwarding-rule::get',
    UPDATE_FORWARDING_RULE: 'dcd/application-loadbalancer/update-forwarding-rule::update',
    PARIALLY_UPDATE_FORWARDING_RULE: 'dcd/application-loadbalancer/partially-update-forwarding-rule::update',
    DELETE_FORWARDING_RULE: 'dcd/application-loadbalancer/delete-forwarding-rule::delete',
  },

  TEMPLATE: {
    GET_ALL: 'dcd/templates::get',
  },

  MONITORING: {
    CONTROLLER_SETTINGS: {
      UPDATE: 'dcd/monitoring/action/update::update',
    },
    ACTION: {
      GET_ALL: 'dcd/monitoring/action/get-all::get',
      GET: 'dcd/monitoring/action/get::get',
      CREATE: 'dcd/monitoring/action/create::create',
      UPDATE: 'dcd/monitoring/action/update::update',
      DELETE: 'dcd/monitoring/action/delete::delete',
      GET_ALL_EXECUTIONS: 'dcd/monitoring/action/get-all-executions::get',
      GET_EXECUTION: 'dcd/monitoring/action/get-execution::get',
    },
    ALARM: {
      GET_ALL: 'dcd/monitoring/alarm/get-all::get',
      GET: 'dcd/monitoring/alarm/get::get',
      CREATE: 'dcd/monitoring/alarm/create::create',
      UPDATE: 'dcd/monitoring/alarm/update::update',
      DELETE: 'dcd/monitoring/alarm/delete::delete',
      GET_ALL_TRANSITIONS: 'dcd/monitoring/alarm/get-all-transitions::get',
      GET_TRANSITION: 'dcd/monitoring/alarm/get-transition::get',
    },
  },

  NAT_GATEWAY: {
    GET_ALL: 'dcd/nat-gateway/get-all::get',
    GET: 'dcd/nat-gateway/get::get',
    CREATE: 'dcd/nat-gateway/create::create',
    UPDATE: 'dcd/nat-gateway/update::update',
    DELETE: 'dcd/nat-gateway/delete::delete',
    CREATE_RULE: 'dcd/nat-gateway/create-rule::create',
    GET_RULE: 'dcd/nat-gateway/get-rule::get',
    GET_ALL_RULES: 'dcd/nat-gateway/get-all-rule::get',
    UPDATE_RULE: 'dcd/nat-gateway/update-rule::update',
    DELETE_RULE: 'dcd/nat-gateway/delete-rule::delete',
  },
  AUTO_SCALING: {
    GROUP: {
      GET_ALL: 'dcd/auto-scaling/group/get-all::get',
      GET: 'dcd/auto-scaling/group/get::get',
      CREATE: 'dcd/auto-scaling/group/create::create',
      UPDATE: 'dcd/auto-scaling/group/update::update',
      DELETE: 'dcd/auto-scaling/group/delete::delete',
      GET_ALL_ACTIONS: 'dcd/auto-scaling/group/get-all-actions::get',
      GET_ACTION: 'dcd/auto-scaling/group/get-action::get',
      SCALE_IN: 'dcd/auto-scaling/group/scale-in::update',
      SCALE_OUT: 'dcd/auto-scaling/group/scale-out::update',
      GET_ALL_SERVERS: 'dcd/auto-scaling/group/get-all-servers::get',
      GET_SERVER: 'dcd/auto-scaling/group/get-server::get',
    },
  },

  LOCATION: {
    GET_ALL: 'dcd/location/get-all::get',
    GET: 'dcd/location/get::get',
    GET_LOCATION: 'dcd/location/get-location::get',
  },

  CERTIFICATE_MANAGER: {
    GET: 'dcd/certificate-manager/get::get',
    GET_ALL: 'dcd/certificate-manager/get-all::get',
    CREATE: 'dcd/certificate-manager/create::create',
    DELETE: 'dcd/certificate-manager/delete::delete',
  },

  DATABASE: {
    POSTGRESQL: {
      GET: 'dcd/database/postgresql/get::get',
      GET_ALL: 'dcd/database/postgresql/get-all::get',
      CREATE: 'dcd/database/postgresql/create::create',
      UPDATE: 'dcd/database/postgresql/update::update',
      DELETE: 'dcd/database/postgresql/delete::delete',
      GET_ALL_VERSIONS: 'dcd/database/postgresql/get-all-version::get',
      GET_UPGRADABLE_VERSIONS: 'dcd/database/postgresql/get-upgradable-version::get',
      GET_ALL_BACKUPS: 'dcd/database/postgresql/backup/get-all::get',
      GET_ALL_BACKUPS_BY_CLUSTER_ID: 'dcd/database/postgresql/backup/get-by-cluster::get',
      GET_BACKUP_BY_ID: 'dcd/database/postgresql/backup/get::get',
      RESTORE_BACKUP: 'dcd/database/postgresql/backup/restore::update',
    },

    MONGODB: {
      GET: 'dcd/database/mongodb/get::get',
      GET_ALL: 'dcd/database/mongodb/get-all::get',
      CREATE: 'dcd/database/mongodb/create::create',
      UPDATE: 'dcd/database/mongodb/update::update',
      DELETE: 'dcd/database/mongodb/delete::delete',
      GET_ALL_VERSIONS: 'dcd/database/mongodb/get-all-version::get',

      GET_TEMPLATES: 'dcd/database/mongodb/get-templates::get',

      GET_ALL_USERS: 'dcd/database/mongodb/get-all-users::get',
      CREATE_USER: 'dcd/database/mongodb/create-user::create',
      UPDATE_USER: 'dcd/database/mongodb/update-user::update',
      DELETE_USER: 'dcd/database/mongodb/delete-user::delete',

      GET_SNAPSHOTS_FOR_CLUSTER: 'dcd/database/mongodb/get-snapshots-for-cluster::get',
      RESTORE_CLUSTER: 'dcd/database/mongodb/restore-cluster::create',
    },

    GET_QUOTA: 'dcd/database/get-quota::get',
  },

  TARGET_GROUP: {
    GET: 'dcd/target-groups/get::get',
    GET_ALL: 'dcd/target-groups/get-all::get',
    CREATE: 'dcd/target-groups/create::create',
    UPDATE: 'dcd/target-groups/update::update',
    UPDATE_PARTIAL: 'dcd/target-groups/update-partial::update',
    DELETE: 'dcd/target-groups/delete::delete',
  },

  CONTAINER_REGISTRY: {
    REGISTRY: {
      CREATE: 'dcd/container-registry/registry/create::create',
      GET: 'dcd/container-registry/registry/get::get',
      GET_V2: 'dcd/container-registry/registry/get-v2::get',
      CHECK_NAME_AVAILABILITY: 'dcd/container-registry/registry/check-name-availability::get',
      GET_ALL: 'dcd/container-registry/registry/get-all::get',
      UPDATE: 'dcd/container-registry/registry/update::update',
      DELETE: 'dcd/container-registry/registry/delete::delete',
    },
    REPOSITORY: {
      GET_ALL: 'dcd/container-registry/repositry/get-all::get',
      GET: 'dcd/container-registry/repositry/get::get',
      GET_TAGS: 'dcd/container-registry/repositry/get-tags::get-custom',
      GET_MANIFEST: 'dcd/container-registry/repositry/get-manifest::get',
      DELETE: 'dcd/container-registry/repositry/delete::delete',
    },
    TOKEN: {
      CREATE: 'dcd/container-registry/token/create::create',
      GET: 'dcd/container-registry/token/get::get',
      GET_ALL: 'dcd/container-registry/token/get-all::get',
      UPDATE: 'dcd/container-registry/token/update::update',
      DELETE: 'dcd/container-registry/token/delete::delete',
    },
    LOCATION: {
      GET_ALL: 'dcd/container-registry/location/get-all::get',
    },
  },
};

const getKey = (name) => (
  JSON.parse(window.localStorage.getItem(name)) || ''
);
const { features = {} } = getConfig() || {};
const { tableViewSwitch = '' } = features;
const listViewType = tableViewSwitch ? getKey('dcd-view') || 'tile' : 'tile';

export const initialState = {
  token: '',
  notifications: [],
  listViewType,
  timeRangeSettings: {
    refreshInterval: 5 * 60 * 1000,
    range: RecentRelativeTimeRange({ unit: 'hours', range: 2 }),
  },
  layout: {},
  screen: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  pendingActions: [],
  sshKeys: [],
  users: [],
  groups: [],
  resources: [],
  groupResouces: [],
  groupUsers: [],
  provisioningItems: [],
  embedData: {},
  billing: {},
  dataCenter: {},
  uploadedImages: [],
  locations: [],
  ips: [],
  cluster: {},
  version: {},
  clusters: [],
  nodepool: {},
  nodes: [],
  loadbalancer: {},
  group: {},
  groupResources: [],
  user: {},
  backupUnit: [],
  templates: [],
  [ACTIONS_TYPES.SERVER.GET_OVERALL_SERVERS]: [],
};
